// src/utils/apiWrapper.js
import { apiRequest } from './api';

export const fetchOrganizationDetails = async () => {
    try {
        const response = await apiRequest('/api/auth/settings/organization', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        const result = await response.json();
        return result; // Assuming the response contains a 'data' field
    } catch (error) {
        console.error('Error fetching organization details:', error);
        throw error;
    }
};

export const fetchTeamMembers = async () => {
    try {
        const response = await apiRequest('/api/auth/settings/team', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        const result = await response.json();
        console.log(result)
        return result.data;
    } catch (error) {
        console.error('Error fetching team members:', error);
        throw error;
    }
};

export const addTeamMember = async (email, name, role) => {
    console.log(`addTeamMember: name ${name} email ${email}, role ${role}`);
    try {
        const body = { email, name, role };
        const response = await apiRequest('/api/auth/settings/team', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        return response;
    } catch (error) {
        console.error('Error adding team member:', error);
        throw error;
    }
};

// In src/utils/apiWrapper.js
export const fetchLoginHistory = async () => {
    try {
      const response = await apiRequest('/api/auth/login/history', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const result = await response.json();
      return result; // assuming the result has a 'loginHistory' field
    } catch (error) {
      console.error('Error fetching login history:', error);
      throw error;
    }
  };
  

export const modifyTeamMember = async (email, newRole, newPermission) => {
    try {
        const body = { role: newRole, permission: newPermission };
        const response = await apiRequest(`/api/auth/settings/team/${email}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        return response.data;
    } catch (error) {
        console.error('Error modifying team member:', error);
        throw error;
    }
};

export const deleteTeamMember = async (email) => {
    try {
        const response = await apiRequest(`/api/auth/settings/team/${email}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting team member:', error);
        throw error;
    }
};

export const updateOrganizationDetails = async (orgData) => {
    try {
        const response = await apiRequest('/api/auth/settings/organization/update', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(orgData),
        });
        return response.data;
    } catch (error) {
        console.error('Error updating organization details:', error);
        throw error;
    }
};
